import React from "react";
import PropTypes from "prop-types";
const DownloadIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 18 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd" transform="translate(-3)">
      <path d="M0 0h24v24H0z" />
      <rect
        width="12"
        height="2"
        x="6"
        y="22"
        fill={color || "var(--color-easil-gray-x-dark)"}
        rx="1"
      />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
        d="M15.002 9.996a1 1 0 0 1-.992-.875l-.781-6.246a1 1 0 0 0-.993-.876h-.469a1 1 0 0 0-.992.876l-.78 6.246a1 1 0 0 1-.993.875H6.054a782.851 782.851 0 0 0 4.637 5.873c.542.678.978 1.216 1.306 1.613.154-.186.33-.403.528-.647.68-.84 1.597-1.99 2.69-3.372l.071-.088c.85-1.076 1.757-2.227 2.662-3.379h-2.946zm-2.37 8.227a.222.222 0 0 0 .005.005l-.005-.005zm3.253-10.226h4.117a1 1 0 0 1 .788 1.615l-.337.43a1340.467 1340.467 0 0 1-3.598 4.573l-.07.089a408.873 408.873 0 0 1-2.706 3.39c-.391.482-.702.86-.926 1.125-.123.146-.222.259-.298.341-.048.053-.09.096-.132.135-.267.25-.332.297-.721.297-.683 0-.153.663-8.788-10.38a1 1 0 0 1 .788-1.615h4.117l.672-5.37A3 3 0 0 1 11.767 0h.47a3 3 0 0 1 2.976 2.627l.672 5.37z"
      />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
        d="M15.002 9.996a1 1 0 0 1-.992-.875l-.781-6.246a1 1 0 0 0-.993-.876h-.469a1 1 0 0 0-.992.876l-.78 6.246a1 1 0 0 1-.993.875H6.054a782.851 782.851 0 0 0 4.637 5.873c.542.678.978 1.216 1.306 1.613.154-.186.33-.403.528-.647.68-.84 1.597-1.99 2.69-3.372l.071-.088c.85-1.076 1.757-2.227 2.662-3.379h-2.946zm-2.37 8.227a.222.222 0 0 0 .005.005l-.005-.005zm3.253-10.226h4.117a1 1 0 0 1 .788 1.615l-.337.43a1340.467 1340.467 0 0 1-3.598 4.573l-.07.089a408.873 408.873 0 0 1-2.706 3.39c-.391.482-.702.86-.926 1.125-.123.146-.222.259-.298.341-.048.053-.09.096-.132.135-.267.25-.332.297-.721.297-.683 0-.153.663-8.788-10.38a1 1 0 0 1 .788-1.615h4.117l.672-5.37A3 3 0 0 1 11.767 0h.47a3 3 0 0 1 2.976 2.627l.672 5.37z"
      />
    </g>
  </svg>
);
DownloadIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default DownloadIcon;
